import styled, { keyframes } from 'styled-components';

const shimmer = keyframes`
  0% {
    background-position: -200px 0;
  }
  100% {
    background-position: calc(200px + 100%) 0;
  }
`;

export const Container = styled.div`
  width: 100%;
  margin: 0;
  padding: 24px 2px;
  background: ${(props: any) => props.theme.colors.cf8f9fa};
  min-height: 100vh;
  --skeleton-padding-inline: 2px;

  @media (min-width: 768px) {
    padding: 32px 2px;
    --skeleton-padding-inline: 2px;
  }

  @media (min-width: 1200px) {
    padding: 32px 2px;
    --skeleton-padding-inline: 2px;
  }
`;

export const SkeletonHeader = styled.div`
  background: ${(props: any) => props.theme.colors.ce9ecef};
  padding: 16px 12px;
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
  margin-bottom: 24px;

  @media (min-width: 768px) {
    padding: 16px 16px;
  }

  @media (min-width: 1200px) {
    padding: 16px 20px;
  }
`;

export const SkeletonCard = styled.div`
  background: ${(props: any) => props.theme.colors.white};
  border-radius: 8px;
  margin-bottom: 16px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  overflow: hidden;

  @media (min-width: 768px) {
    margin-bottom: 18px;
  }

  @media (min-width: 1200px) {
    margin-bottom: 20px;
  }

  &:last-child {
    margin-bottom: 0;
  }
`;

export const SkeletonText = styled.div<{ width: string; height: string; marginBottom?: string }>`
  width: ${props => props.width};
  height: ${props => props.height};
  background: linear-gradient(90deg, ${(props: any) => props.theme.colors.cf0f0f0} 25%, ${(props: any) => props.theme.colors.ce0e0e0} 50%, ${(props: any) => props.theme.colors.cf0f0f0} 75%);
  background-size: 200px 100%;
  animation: ${shimmer} 1.5s infinite;
  border-radius: 4px;
  margin-bottom: ${props => props.marginBottom || '0'};
`;

export const SkeletonChip = styled.div<{ width: string; height: string }>`
  width: ${props => props.width};
  height: ${props => props.height};
  background: linear-gradient(90deg, ${(props: any) => props.theme.colors.cf0f0f0} 25%, ${(props: any) => props.theme.colors.ce0e0e0} 50%, ${(props: any) => props.theme.colors.cf0f0f0} 75%);
  background-size: 200px 100%;
  animation: ${shimmer} 1.5s infinite;
  border-radius: 12px;
`;
